<template>
  <div id="video-test">
    <skeleton  ></skeleton>
     <!-- <upload ref="imageUpload"
      :isNeedPreview="true"
      >
      </upload>

      <div @click="uploadToAli">上传到阿里云</div>
      <img class="img-box" :src="resultUrl" alt="resultUrl" @click="seeImg"> -->

  </div>
</template>

<script>
// import ChimeePlayer from 'chimee-player'
// import ChimeeMobilePlayer from 'chimee-mobile-player'
// import '../../node_modules/_chimee-mobile-player@0.2.8@chimee-mobile-player/lib/chimee-mobile-player.browser.css'
import upload from '@/components/public/imageUpload'
import wx from 'weixin-js-sdk'
import skeleton from "@/components/skeleton/skeleton"
export default {
  data () {
    return {
      url: null,
      Chimee: null,
      isFull: false,
      tcplayer: null,
      resultUrl: null,
      // bgcImg: '../assets/img/common-img/emoji_spritesheet_0.png',
      styles: {
        height: '56px',
        width: '56px'
        // background: 'red'
      }
    }
  },
  components: {
    upload, skeleton
  },
  watch: {

    isFullScreen: {
      // handler (n, o) {
      //   console.log(n, '------')
      //   alert(n)
      // }
    }
  },
  mounted () {
    this.setUrl()
    this.$nextTick(() => {
      // this.initTcPlayer()
      // this.videoPlay()
      // this.videoFull()
      // this.initPlayer()
    })
  },
  methods: {
    uploadToAli () {
      let url = 'consult/upload'
      let formFile = new FormData()
      // const targetFile = this.$refs.imageUpload.imagesFiles[0].bigBlob
      console.log(this.$refs.imageUpload.imagesFiles, 'imagesFiles')
      const targetFile = this.$refs.imageUpload.imagesFiles[0].smallBlob
      let params = {
        'file': targetFile
      }
      console.log(targetFile, '我是要上传的文件')
      formFile.append('file', targetFile)
      this.$http
        .post(url, this.$ObjToFd(params), {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(res => {
          if (res.data.error === 0) {
            let imgUrl = res.data.data.xdurl
            this.resultUrl = imgUrl
            console.log(imgUrl)
          }
        })
    },
    setUrl () {
      this.url = 'https://video.shendutv.com/d0471ef3e4be4e2f9c042de13556e4d0/1bee4e6e30a44f639876d75913aca745-b9b90ff2d185429e65e7f67fb5cfc3e9-ld.mp4'
    },
    initTcPlayer () {
      // eslint-disable-next-line
      this.tcplayer = new TcPlayer('wrapper', {
        'mp4': 'https://video.shendutv.com/d0471ef3e4be4e2f9c042de13556e4d0/1bee4e6e30a44f639876d75913aca745-b9b90ff2d185429e65e7f67fb5cfc3e9-ld.mp4', // 请替换成实际可用的播放地址
        // 'autoplay': true, // iOS下safari浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
        'coverpic': 'http://www.test.com/myimage.jpg',
        'width': '100%', // 视频的显示宽度，请尽量使用视频分辨率宽度
        'height': '211', // 视频的显示高度，请尽量使用视频分辨率高度
        'controls': 'none',
        // 'x5_player': true,
        // 'x5_playsinline': 'true',
        'x5_type': 'h5',
        'preload': true
      })
      // if (document.querySelector('video')) {
      let video = document.querySelector('video')
      video.removeAttribute('webkit-playsinline')
      video.removeAttribute('playsinline')
      video.removeAttribute('x-webkit-airplay')
      // }
    },
    goFull () {
      if (this.tcplayer.playing()) {
        this.tcplayer.pause()
      }
      // let ref = this.$refs.fullVideoRef
      let video = document.querySelector('video')
      video.removeAttribute('webkit-playsinline')
      video.removeAttribute('playsinline')
      video.setAttribute('controlsList', 'nofullscreen ')
      video.setAttribute('controls', '')
      /* eslint-disable */
      let timeOut = setTimeout(() => {
        video.play()
        // this.tcplayer.play()
      }, 500)
      // console.log(this.isFullScreen(), 'isFullScreen')
      console.log(video, 'video')
    },
    goplay () {
      // if (this.isFullScreen()) {
      // this.tcplayer.play()

      // this.tcplayer.pause()
      console.log(this.tcplayer.playing(), 'isplaying')
      // }
      let video = document.querySelector('video')
      video.setAttribute('webkit-playsinline', '')
      video.setAttribute('playsinline', '')
      let timeOut = setTimeout(() => {
        this.tcplayer.togglePlay()
      }, 100)
      // }
    },
    // 进入全屏
    FullScreen () {
      var ele = document.documentElement
      if (ele.requestFullscreen) {
        ele.requestFullscreen()
      } else if (ele.mozRequestFullScreen) {
        ele.mozRequestFullScreen()
      } else if (ele.webkitRequestFullScreen) {
        ele.webkitRequestFullScreen()
      }
    },
    // 退出全屏
    exitFullscreen () {
      var de = document
      if (de.exitFullscreen) {
        de.exitFullscreen()
      } else if (de.mozCancelFullScreen) {
        de.mozCancelFullScreen()
      } else if (de.webkitCancelFullScreen) {
        de.webkitCancelFullScreen()
      }
    },
    // 判断是否全屏
    isFullScreen () {
      // alert(document.isFullScreen || document.mozIsFullScreen || document.webkitIsFullScreen)
      return document.isFullScreen || document.mozIsFullScreen || document.webkitIsFullScreen
    },
    // 重写全屏
    videoFull () {
      let bindFull = document.querySelector('.vcp-fullscreen-toggle')
      // bindFull.unbind('click')
      console.log(bindFull, 'bindFull')
      console.log(bindFull.play(), 'bindFull.play')
      bindFull.addEventListener('click', () => {
        this.goFull()
      })
    },
    videoPlay () {
      let bindPlay = document.querySelector('.vcp-playtoggle')
      let time = setTimeout(() => {
        // bindPlay.unbind('click')
      }, 100)
      console.log(bindPlay, 'bindPlay')
      // bindPlay.addEventListener('click', () => {
      //   this.goplay()
      // })
    },
    // 获取数据
    fetch () {
      let params = {
        item_id: this.itemId
      }
      let url = `home/video_detail?item_id=${params.item_id}`
      this.$http.get(url).then(res => {
        if (res.data.code == '0') {
          this.videoUrl = res.data.data.aliyun_mp4_play_url
          this.testId = this.itemId
          this.$nextTick(() => {
            this.bgcImg = res.data.data.aliyun_cover_url
          })
          console.log(this.bgcImg, 'bgcImg')
        }
      })
    },
    // 预览图片
    seeImg () {
      wx.ready(() => {
        wx.previewImage({
          // current: 'String', // 当前显示图片的链接，不填则默认为 urls 的第一张
          current: 'https://wx.shendutv.com/upload/chat/image/2018/11/29/2018112917090876142.jpeg',
          urls: ['https://wx.shendutv.com/upload/chat/image/2018/11/29/2018112917090876142.jpeg'],
          success: function (res) {
            // success
          },
          fail: function () {
            // fail
          },
          complete: function () {
            // complete
          }
        })
      })
    },
  }
}
</script>

<style lang="postcss">
#video-test{
  & .video-box{
    height: 422px;
    width: 100%;
  }
  & .video-wrapper {
    position: relative;
  }
  & .play-wrapper{
    height: 90px;
    width: 100px;
    /* background-color: red; */
    position: absolute;
    bottom: 0;
    z-index: 999;
  }
  & .full-wrapper{
    height: 90px;
    width: 100px;
    /* background-color: red; */
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 999;
  }
  & .img-box{
    /* width: 100%;
    height: 100%; */
  }
  & .test{
    border: 1px solid white;
    /* background: url('../assets/img/common-img/emoji_spritesheet_0.png');
    height: 112px;
    width: 112px; */
  }
}
</style>



// WEBPACK FOOTER //
// src/components/VideoTest.vue